import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Button, Form, message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@/services/api';
import { CreateForm } from './CreateForm';
import { CreateModal } from './CreateModal';
import { ListItens, EmptyList } from './List';

interface OrganizationProps {
	data: any;
	visible?: boolean;
	filtered: boolean;
	specialPlan?: boolean;
	onSelect: (organization: any) => void;
	onClose: () => void;
}

const { useForm } = Form;

export function Organization({
	data,
	visible = false,
	filtered,
	specialPlan = false,
	onSelect,
	onClose
}: Readonly<OrganizationProps>) {
	const [form] = useForm();
	const queryClient = useQueryClient();

	const { isLoading, mutate } = useMutation(
		(values: any) => Api.post('/organization/create', { ...values, url_logo: '' }),
		{
			onError: (err: any) => {
				const response = err?.response?.data?.errors[0];
				const errorMessage = `${response?.msg}: ${response?.param}`;
				message.error(I18n.get(errorMessage));
			},
			onSuccess: (organization) => {
				queryClient.invalidateQueries(['organizations']);
				onClose();
				onSelect(organization.data);
				message.success(I18n.get('Company created successfully'));
			}
		}
	);

	function handleOnSubmit(): void {
		form.validateFields().then((values) => {
			mutate(values);
		});
	}

	if (data?.length === 0 && !filtered) {
		return (
			<>
				<EmptyList description={I18n.get('Welcome to Kinebot, create your first company')} />
				<div style={{ padding: '10px 20px 0' }}>
					<CreateForm form={form} type="organization" />
					<Button type="primary" loading={isLoading} disabled={!specialPlan} onClick={handleOnSubmit}>
						{I18n.get('Create company')}
					</Button>
				</div>
			</>
		);
	}

	return (
		<>
			<CreateModal
				form={form}
				loading={isLoading}
				type="organization"
				onSubmit={handleOnSubmit}
				onCancel={onClose}
				visible={visible}
			/>
			<ListItens data={data} onAction={onSelect} />
		</>
	);
}
